import { useEffect, useState } from "react";
import { db } from "utils/firebase";
import logFirestoreError from "utils/logFirestoreError";
import type { PublishedCustomForm } from "utils/customDataPresentation";

const EMPTY_FORMS: PublishedCustomForm[] = [];

/** Called once by RestaurantContext, shared by all reservation views. */
export default function usePublishedCustomForms(
    restaurantId: string | null,
    uid?: string | null
) {
    const scope = restaurantId && uid ? `${restaurantId}:${uid}` : null;
    const [snapshot, setSnapshot] = useState<{
        scope: string | null;
        forms: PublishedCustomForm[];
    }>({
        scope: null,
        forms: EMPTY_FORMS
    });
    useEffect(() => {
        let current = true;
        setSnapshot({ scope, forms: EMPTY_FORMS });
        if (!restaurantId || !uid) return;
        const path = `restaurants/${restaurantId}/customElementFormulars`;
        const unsubscribe = db.collection(path).onSnapshot(
            (result) => {
                if (!current) return;
                setSnapshot({
                    scope,
                    forms: result.docs.map(
                        (doc) =>
                            ({
                                ...doc.data(),
                                id: doc.id
                            } as PublishedCustomForm)
                    )
                });
            },
            (error) => {
                if (!current) return;
                setSnapshot({ scope, forms: EMPTY_FORMS });
                logFirestoreError("usePublishedCustomForms", path, error);
            }
        );
        return () => {
            current = false;
            unsubscribe();
        };
    }, [restaurantId, uid, scope]);
    return snapshot.scope === scope ? snapshot.forms : EMPTY_FORMS;
}
